import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastController } from '@ionic/angular';
import { NaploService } from '../naplo.service';

@Component({
  selector: 'app-naplo-naplofokonyv',
  templateUrl: './naplofokonyv.component.html',
  styleUrls: ['../naplo-shared.scss'],
})
export class NaplofokonyvComponent implements OnInit {
  adat: any = null;
  partnerek: any[] = [];
  penztarak: any[] = [];
  szuro = { tol: '', ig: '', partnerId: '', penztarId: '' };
  fooszlopFejlecek = ['Értékesítés árbev.', 'Egyéb bevétel', 'Anyag, áru', 'Munkabér', 'Közterhek', 'Egyéb ráford.', 'Egyéb kiadás'];

  constructor(private naplo: NaploService, private toast: ToastController, private router: Router) {}

  get aktiv() { return this.naplo.aktiv; }

  async ngOnInit() {
    await this.naplo.init();
    if (this.aktiv.konyveles_mod === 'kettos') { this.router.navigateByUrl('/naplo/kettos?nezet=kivonat'); return; }
    if (!this.aktiv.ugyfelId) return;
    [this.partnerek, this.penztarak] = await Promise.all([
      this.naplo.get('/partnerek/' + this.aktiv.ugyfelId), this.naplo.get('/penztarak/' + this.aktiv.ugyfelId),
    ]);
    await this.betolt();
  }

  async betolt() {
    try {
      this.adat = await this.naplo.get('/naplofokonyv/' + this.aktiv.ugyfelId + this.naplo.evq(this.szuro));
    } catch { (await this.toast.create({ message: 'Nem sikerült lekérni a naplófőkönyvet.', duration: 2500, color: 'danger' })).present(); }
  }

  szurest() { this.betolt(); }
  szuroTorles() { this.szuro = { tol: '', ig: '', partnerId: '', penztarId: '' }; this.betolt(); }

  export() {
    if (!this.adat?.sorok?.length) return;
    const fej = ['Sorszám', 'Dátum', 'Bizonylat', 'Partner', 'Megjegyzés', 'Pénztár', ...this.fooszlopFejlecek, 'Bevétel', 'Kiadás'];
    const sorok = this.adat.sorok.map((r: any) => [
      r.sorszam, r.datum, r.bizonylatszam || '', r.partner_nev || '', (r.megjegyzes || '').replace(/;/g, ','), r.penztar_azon || '',
      ...[1, 2, 3, 4, 5, 6, 7].map(i => r.oszlopok[i] || 0), r.bevetel, r.kiadas,
    ]);
    const csv = [fej, ...sorok].map(s => s.join(';')).join('\n');
    const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob); a.download = `naplofokonyv_${this.aktiv.ev}.csv`; a.click();
  }
}
